import { Modal, Flex, Button } from '@mantine/core';

interface ManualModalProps {
  opened: boolean;
  onClose: () => void;
}

const MANUAL_LINKS = [
  {
    href: 'https://become-hub.s3.eu-central-1.amazonaws.com/pdf/BECOME+-+Manuale+-+Augmented+Life+Experience.pdf',
    label: 'Manuale - Augmented Life Experience',
  },
  {
    href: 'https://become-hub.s3.eu-central-1.amazonaws.com/pdf/BECOME+-+Manuale+-+Augmented+Food+Exposure.pdf',
    label: 'Manuale - Augmented Food Exposure',
  },
  {
    href: 'https://become-hub.s3.eu-central-1.amazonaws.com/pdf/BECOME+-+Manuale+-+Augmented+Performance.pdf',
    label: 'Manuale - Augmented Performance',
  },
] as const;

export const ManualModal = ({ opened, onClose }: ManualModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Seleziona il manuale da scaricare'
      centered
    >
      <Flex direction='column' gap='sm'>
        {MANUAL_LINKS.map(link => (
          <Button
            key={link.href}
            component='a'
            href={link.href}
            target='_blank'
            variant='light'
            fullWidth
          >
            {link.label}
          </Button>
        ))}
      </Flex>
    </Modal>
  );
};
